import { FC } from 'react';
import { DisputeVisibility, DisputeWindow } from '../disputeVisibility.model';
import DisputeSectionHeader from './DisputeSectionHeader';
import DisputeValueLink from './DisputeValueLink';
import { DisputeZoneChip } from './DisputeZoneChip';

interface DisputeRateSectionProps {
  summary: DisputeVisibility;
  onPayments: (disputeWindow: DisputeWindow, action: string) => void;
  onDisputed: (disputeWindow: DisputeWindow, action: string) => void;
}

const DisputeRateSection: FC<DisputeRateSectionProps> = ({ summary, onPayments, onDisputed }) => {
  const { openDisputes } = summary;

  if (!summary.windows.length && !openDisputes) return null;

  return (
    <section>
      {summary.rateTitle ? <DisputeSectionHeader text={summary.rateTitle} /> : null}
      <div className="rounded-md border border-borderGray p-4">
        {summary.windows.map((disputeWindow, index) => (
          <div key={disputeWindow.days}>
            {index > 0 ? <div className="my-3 h-px bg-secondaryBtn" /> : null}
            <div className="flex items-center gap-3">
              <span className="flex-1 text-sbase font-semibold text-heading">{disputeWindow.title}</span>
              <DisputeZoneChip text={disputeWindow.chip} zone={disputeWindow.zone} />
            </div>
            <div className="mt-2.5 flex flex-col gap-2">
              <DisputeValueLink
                label="Payments collected"
                value={disputeWindow.paymentsCollected}
                onClick={() => onPayments(disputeWindow, `payments_collected_${disputeWindow.days}`)}
              />
              <DisputeValueLink
                label="Disputed"
                value={disputeWindow.disputed}
                onClick={() => onDisputed(disputeWindow, `disputed_${disputeWindow.days}`)}
              />
            </div>
          </div>
        ))}
        {openDisputes ? (
          <>
            {summary.windows.length ? <div className="my-3 h-px bg-secondaryBtn" /> : null}
            <div className="flex items-center gap-3">
              <span className="flex-1 text-sbase font-semibold text-heading">Open disputes</span>
              <span className="text-sbase font-bold text-tertiaryText">{openDisputes.amount}</span>
            </div>
            {openDisputes.line ? <p className="mt-1 text-px13 text-accentText">{openDisputes.line}</p> : null}
          </>
        ) : null}
      </div>
    </section>
  );
};

export default DisputeRateSection;
